import type { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "Data/Redux/Store";
import type { SystemEventState } from "Interfaces";

const initialState: SystemEventState = {
	alarmOut: false,
	email: false,
	snapshot: false,
	ftp: false
};

const setSystemEventReducer = (state: SystemEventState, action: PayloadAction<SystemEventState>) => {
	return action.payload;
};

const getSystemEvent = (state: SystemEventState) => {
	return state;
};

const systemEventSlice = createAppSlice({
	initialState,
	name: "systemEvent",
	reducers: {
		setSystemEventAction: setSystemEventReducer
	},
	selectors: {
		selectSystemEvent: getSystemEvent
	}
});

export default systemEventSlice;

export const { setSystemEventAction } = systemEventSlice.actions;
export const { selectSystemEvent } = systemEventSlice.selectors;
